import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    Group as GroupIcon,
    EmojiObjects as EmojiObjectsIcon,
    PeopleAlt as PeopleAltIcon,
    Favorite as FavoriteIcon,
    WarningAmber as WarningAmberIcon,
    CheckCircleOutline as CheckCircleOutlineIcon,
    Search as SearchIcon,
    TipsAndUpdates as TipsAndUpdatesIcon,
    Diversity3 as Diversity3Icon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('enjoy-differences')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    趣味の違いを楽しむコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('distance')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    距離感の取り方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('find-common-hobby')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    共通の趣味を見つける方法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-avoid')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    トラブル回避術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    ルームシェア生活は、異なる価値観やライフスタイルを持つ他人と住むことで、日々新しい発見や刺激が生まれます。しかし「趣味が合わない」ことがきっかけで、すれ違いやストレスを感じてしまう人も少なくありません。
                </Typography>
                <Typography variant="body1" paragraph>
                    本記事では、趣味の違いを前向きに捉えて楽しむ工夫や、お互いが快適に過ごすための距離感のとり方、共通点の見つけ方、そしてトラブルを未然に防ぐコツまで具体的に解説します。さまざまな経験と知見をもとに、ルームシェアをもっと豊かにするヒントをお届けします。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/share-living-meal_roomshare-hobbies-tips.jpg"
                        alt="明るい共有リビングで、異なる趣味を持つルームメイトたちが一緒に食事を楽しみながら会話している様子。リラックスした雰囲気と多様性のある空間が伝わる"
                        style={{ width: '100%', borderRadius: 12, marginTop: 8, marginBottom: 8 }}
                    />
                </Box>
            </Box>

            {/* 趣味の違いを楽しむコツ */}
            <Box id="enjoy-differences" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <Diversity3Icon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    趣味の違いを楽しむコツ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    趣味が合わないからといって「居心地が悪い」「気まずい」だけで終わらせてしまうのはもったいないことです。実は、趣味の違いは新しい世界を知る絶好のチャンスでもあります。
                </Typography>
                <Paper elevation={0} sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2, mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        <EmojiObjectsIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'primary.main' }} />
                        ポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="相手の趣味を否定しない"
                                secondary="「それって面白いんだね」と関心を持ち、話を聞いてみるだけでも印象が大きく変わります。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><EmojiObjectsIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="自分の趣味を押し付けない"
                                secondary="無理に一緒に楽しもうとするより、自然な形で興味を持ってもらうのがベターです。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><GroupIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="新しい価値観との出会いを楽しむ"
                                secondary="普段触れない趣味を知ることで、視野が広がり、人間関係もより豊かになります。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" paragraph>
                    例えば映画好きとアウトドア好きが同居している場合、映画の話題で盛り上がった後に、一度だけ一緒にキャンプへ行くなど、互いの世界に少しずつ触れてみると、意外な共通点が見つかることも多いです。
                </Typography>
            </Box>

            {/* 距離感の取り方 */}
            <Box id="distance" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <PeopleAltIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    距離感の取り方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    共同生活では「適度な距離感」を保つことが、長く快適に暮らすためのコツです。特に趣味が大きく違う場合、お互いの時間や空間を尊重する意識が重要になります。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" gutterBottom>
                                    <FavoriteIcon sx={{ color: 'secondary.main', verticalAlign: 'middle', mr: 1 }} />
                                    プライベートを大切に
                                </Typography>
                                <Typography variant="body2">
                                    それぞれの趣味時間を確保できるよう、部屋やコーナーを分ける、イヤホンを使うなどの工夫が効果的です。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Typography variant="subtitle1" gutterBottom>
                                    <GroupIcon sx={{ color: 'primary.main', verticalAlign: 'middle', mr: 1 }} />
                                    コミュニケーションのルールを
                                </Typography>
                                <Typography variant="body2">
                                    「この時間は静かにしてほしい」「週末はリビングを使いたい」など、事前に伝え合うことで摩擦を防げます。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    
                </Box>
                <Typography variant="body2" paragraph>
                    距離を取ることは「仲が悪い」わけではありません。無理に一緒に過ごすより、適度な距離がある方がかえって心地よい関係を築けるのです。
                </Typography>
            </Box>

            {/* 共通の趣味を見つける方法 */}
            <Box id="find-common-hobby" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <SearchIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                    共通の趣味を見つける方法
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    趣味が全く合わないように思えても、意外と「ここなら一緒に楽しめる！」というポイントが見つかるものです。共通の話題や活動が生まれると、ルームシェア生活はぐっと楽しくなります。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <TipsAndUpdatesIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="興味リストを共有する"
                            secondary="お互いの好きなこと・やってみたいことを紙やアプリでリストアップしてみましょう。意外な一致点が見つかることも。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutlineIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="イベントや体験を提案する"
                            secondary="「一度だけ一緒にやってみない？」と気軽に誘ってみる。無理強いせず、断られてもOKくらいの気持ちが大切です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FavoriteIcon color="secondary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="料理やボードゲームなど“ゆるい”趣味を探す"
                            secondary="深くなくてもOK。「ちょっと面白そう」で始められるアクティビティが、距離を縮めるきっかけになります。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ my: 3 }}>
                    
                </Box>
                <Typography variant="body2">
                    共通の趣味が生まれたら、そこから会話や交流が広がりやすくなります。たとえ一つだけでも「一緒に楽しめること」があると、シェア生活がより豊かなものになるでしょう。
                </Typography>
            </Box>

            {/* トラブル回避術 */}
            <Box id="trouble-avoid" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <WarningAmberIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'warning.main' }} />
                    トラブル回避術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    趣味の違いが原因でトラブルに発展しないためには、いくつかの大切なポイントを押さえておくことが重要です。
                </Typography>
                <Paper elevation={1} sx={{ bgcolor: '#fffde7', p: 2, borderRadius: 2, mb: 2, border: '1px solid #ffe082' }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        <WarningAmberIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'warning.main' }} />
                        注意点・チェックリスト
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="音や匂いへの配慮"
                                secondary="楽器演奏やアロマ、料理の匂いなどは思った以上に相手に影響します。事前の声かけ・相談を忘れずに。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="趣味の道具・スペースの使い方"
                                secondary="共用スペースに私物が広がりすぎるとストレスの元に。収納のルールや片付けを徹底しましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="「言いにくいこと」もきちんと伝える"
                                secondary="気になることは溜め込まず、冷静に・丁寧に伝えることで大きなトラブルを防げます。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" paragraph>
                    また、LINEやSlackなど連絡ツールを活用して、直接言いにくいことはメッセージで伝えるのもひとつの方法です。定期的な「シェア会議」を設けると、問題の早期発見や改善がしやすくなります。
                </Typography>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ p: 3, bgcolor: '#e3f2fd', borderRadius: 2 }}>
                    <Typography variant="body1" paragraph>
                        ルームシェアは、異なる価値観や趣味が交差する場所です。趣味が合わないからこそ、互いの違いを尊重し合い、新たな刺激や学びに変えていくことができます。
                    </Typography>
                    <Typography variant="body1" paragraph>
                        大切なのは「無理に合わせよう」とせず、適度な距離感とオープンなコミュニケーション、そして小さな共通点を大切にすること。これが、快適で楽しいシェア生活を送るための秘訣と言えるでしょう。
                    </Typography>
                </Box>
                <Box sx={{ mt: 4 }}>
                    
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-hobbies-tips',
    slug: 'roomshare-hobbies-tips',
    title: 'ルームシェアで「趣味が合わない」場合の工夫',
    excerpt: '趣味の違いを楽しむコツ、距離感の取り方、共通の趣味を見つける方法、トラブル回避術など、ルームシェアで趣味が合わないときに役立つ実践的なヒントを専門家が解説します。',
    coverImage: '/images/blog/cover-roomshare-hobbies_roomshare-hobbies-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な趣味を持つルームメイトたちが互いの違いを尊重しながら楽しく過ごしている様子。カラフルなインテリアとリラックスした雰囲気が印象的な空間',
    publishedAt: '2024-06-24T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '人間関係', 'ライフスタイル'],
    tags: ['ルームシェア', '趣味の違い', 'トラブル回避', '距離感', '共通点探し'],
    author: {
        name: '佐藤 遼介',
        avatar: '/images/avatars/sato-ryosuke.jpg',
        bio: '首都圏で100件以上のルームシェア仲介とコミュニティ運営経験を持つシェアライフアドバイザー。多様な価値観が交わる住まい作りをサポートしています。',
        profilePicture: '/images/avatars/sato-ryosuke.jpg'
    },
    viewCount: 1850,
    contentComponent: PostContent
};

export default post;